import { useUnsavedChangesGuardStore } from '@/store/store'

// Wraps an in-app navigation action (tab switch, etc.) so it pauses behind the
// UnsavedChangesModal confirm dialog whenever shouldGuard is true, instead of
// running immediately.
export const useGuardedNavigation = (shouldGuard: boolean) => {
  const requestNavigation = useUnsavedChangesGuardStore((state) => state.requestNavigation)

  return (action: () => void) => {
    if (shouldGuard) {
      requestNavigation(action)
      return
    }
    action()
  }
}
